import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { getAwards } from 'entries/ducks';
import { getProject } from 'project/ducks/project';
import { getCurrentWrapup } from 'project/ducks/wrapup';
import { getSteps } from 'project/components/wrapup/all_tour_steps';
import Tour from 'project/components/wrapup/tour';

const mapStateToProps = (state, { params }) => {
  const user = state.user.profile_data;
  const project = getProject(state);
  const wrapup = getCurrentWrapup(state, params.awardId);
  const awards = getAwards(state, false);
  const allSteps = getSteps({ user, project, wrapup, awards });

  return {
    intro: allSteps.find(s => s.intro),
    steps: allSteps.filter(s => !s.intro),
  };
}

export default withRouter(connect(mapStateToProps)(Tour));



// WEBPACK FOOTER //
// ./project/containers/wrapup/tour.js